const nl = {
  "front.faq.chat.title": "STEL EEN VRAAG",
  "front.faq.chat.description": "directe ondersteuning voor restaurantgasten",
  "front.faq.chat.welcome": "Hier kunt u direct een vraag stellen.",
  "front.faq.chat.placeholder": "bericht",
  "front.faq.chat.send": "verzenden",
  "front.faq.chat.unsupportedLanguage": "Sorry, deze chat ondersteunt momenteel alleen Engels en Duits.",
  "front.faq.chat.fallback": "Bedankt voor uw bericht. Op dit moment kan ik alleen veelgestelde vragen beantwoorden. Neem rechtstreeks contact met ons op voor meer informatie.",

  "front.faq.chat.answer.hours": "Wij zijn dagelijks geopend van 10:00 tot 22:00 uur.",
  "front.faq.chat.answer.reservation": "Ja, u kunt direct via onze website of telefonisch een tafel reserveren.",
  "front.faq.chat.answer.groupReservation": "Neem voor groepsreserveringen rechtstreeks contact met ons op, zodat we de beste optie voor u kunnen vinden.",
  "front.faq.chat.answer.address": "Ons adres is: Musterstraße 1, Berlijn.",
  "front.faq.chat.answer.parking": "Ja, er is parkeergelegenheid in de buurt.",
  "front.faq.chat.answer.phone": "U kunt ons bereiken via +49 000 000000.",
  "front.faq.chat.answer.payment": "Ja, u kunt bij ons contant of met kaart betalen.",
  "front.faq.chat.answer.menu": "U vindt ons actuele menu op de website. Heeft u vragen over specifieke gerechten, dan helpen wij u graag.",
  "front.faq.chat.answer.vegetarian": "Ja, wij bieden vegetarische gerechten aan.",
  "front.faq.chat.answer.vegan": "Ja, wij hebben ook veganistische opties op ons menu.",
  "front.faq.chat.answer.allergens": "Als u allergieën of intoleranties heeft, neem dan rechtstreeks contact met ons op. Wij geven u graag informatie over de ingrediënten.",
  "front.faq.chat.answer.takeaway": "Ja, eten kan ook worden besteld om mee te nemen.",
  "front.faq.chat.answer.delivery": "Op dit moment ondersteunen wij via de website alleen reserveringen en vragen.",
  "front.faq.chat.answer.terrace": "Ja, bij mooi weer kunt u ook op ons terras zitten.",
  "front.faq.chat.answer.pets": "Neem rechtstreeks contact met ons op als u met een huisdier wilt komen.",
  "front.faq.chat.answer.children": "Ja, gezinnen met kinderen zijn van harte welkom.",
  "front.faq.chat.answer.wifi": "Ja, er is wifi beschikbaar voor onze gasten.",

  "front.acquaintance.callback.placeholder": "Je telefoonnummer",
  "front.acquaintance.callback.send": "Verzenden",
  "front.acquaintance.callback.sending": "Verzenden...",
  "front.acquaintance.callback.invalidPhone": "Voer een geldig telefoonnummer in.",
  "front.acquaintance.callback.success": "Aanvraag verzonden. Ik neem binnenkort contact met je op.",
  "front.acquaintance.callback.error": "Fout bij het verzenden van de aanvraag. Probeer het opnieuw.",

  "front.landingSeo.links.digitalMenu": "Digitaal menu voor restaurants",
  "front.landingSeo.links.qrMenu": "QR-code menu voor restaurants",
  "front.landingSeo.links.multilingualMenu": "Meertalig menu voor restaurants",
  "front.landingSeo.links.reservation": "Online tafelreservering voor restaurants",
  "front.landingSeo.links.freeDigitalMenu": "Test gratis een digitaal menu",
  "front.landingSeo.links.changeMenuOnline": "Menu online wijzigen",
  
  "menu.title": "Menu",
  "menu.promo": "Speciale aanbiedingen",
  "menu.empty.categoryTitle": "Vul de categorienaam in",
  "menu.empty.itemTitle": "Vul de productnaam in",
  "menu.empty.itemDescription": "Vul de productbeschrijving in",
  "cart.add": "Toevoegen aan winkelwagen",
  "cart.cancel": "Annuleren",
  "section.video": "Videopresentatie",
  "section.tables": "ONLINE TAFELRESERVERING",
  "section.table": "KIES EEN TAFEL",
  "section.menu": "Restaurantmenu",
  "section.faq": "FAQ",
  "section.contact": "Contact",
  "promo.buy": "Kopen",

  "front.tenant.resolving": "Restaurant wordt via subdomein herkend…",
  "front.tenant.notFound": "Geen klant gevonden voor dit subdomein",
  "front.tenant.resolveError": "Klant kon niet worden bepaald",
  "front.menu.loading": "Laden…",
  "front.menu.loadError": "Menu kon niet worden geladen",
  "front.menu.addtocart": "Winkelwagen",
  "front.menu.cancel": "Annuleren",
  "front.Number.servings": "Aantal porties",

  "orbit.menu": "MENU",
  "orbit.shef": "RESERVERING",
  "orbit.video": "VIDEO",
  "orbit.faq": "VRAGEN",
  "orbit.interior": "INTERIEUR",
  "orbit.footer": "SOCIALE MEDIA",

  "shef.title.line1": "ONLINE",
  "shef.title.line2": "RESERVERING",
  "shef.banner.label": "Kies",
  "shef.banner.main": "uw tafel",
  "shef.reserved": "GERESERVEERD",

  "video.title": "ZO KOKEN WIJ - EERLIJK EN LEKKER",
  "video.add": "Video toevoegen",
  "add.video.but": "Toevoegen",

  "interior.title": "ONS INTERIEUR",

  "footer.kontact": "CONTACTEN",

  "telegram.title": "Om Telegram-meldingen voor bestellingen in te stellen, moet u het volgende doen:",
  "telegram.title.first": "1. BOT_TOKEN verkrijgen",
  "telegram.text.first": "Om een BOT_TOKEN te krijgen, zoekt en start u de @BotFather-bot in Telegram, stuurt u de opdracht /newbot, volgt u de instructies om een unieke botnaam en gebruikersnaam te maken en kopieert u daarna de API-token die @BotFather als antwoord stuurt.",
  "telegram.title.two": "2. CHAT_ID verkrijgen",
  "telegram.text.two": "Om de CHAT_ID te krijgen, zoekt en start u de @UserInfoBot-bot in Telegram, stuurt u de opdracht /start en kopieert u vervolgens de ID die u in het antwoordbericht ontvangt.",

  "cart.title": "UW WINKELWAGEN",
  "cart.header.aria": "Uw winkelwagen",
  "cart.toggle.expand": "Winkelwagen uitklappen",
  "cart.toggle.collapse": "Winkelwagen inklappen",
  "cart.total.label": "Totaal",
  "cart.total.products": "producten",
  "cart.button.primary": "bestellen",
  "cart.button.back": "terug",
  "cart.button.waiter": "OBER",

  "cart.mode.takeaway": "afhalen",
  "cart.mode.tableTime": "Tijd en tafel",
  "cart.mode.tableTime.disabled": "geen vrije tafels",
  "cart.mode.tableTime.tooltip": "Tijd en tafel",
  "cart.mode.tableTime.tooltipNoFree": "geen vrije tafels",
  "cart.mode.inHouse": "ter plaatse",

  "cart.bookingFlow.title": "RESERVERING. TAFELNUMMER",
  "cart.deposit.itemTitle": "Tafelreservering (aanbetaling)",
  "cart.deposit.lineTitle": "Aanbetaling",
  "cart.deposit.badge": "Aanbetaling {amount}€",

  "cart.table.msg.tempChosen": "Tafel {table} voorlopig gekozen ✓",
  "cart.table.msg.noFree": "Helaas zijn er geen vrije tafels",
  "cart.table.msg.chooseOrDefault": "Kies een tafel of gebruik de standaardselectie.",

  "cart.table.select.reserved": "GERESERVEERD",
  "cart.table.select.pick": "KIEZEN",
  "cart.table.select.any": "WILLEKEURIG",

  "cart.inHouse.title": "KIES UW TAFELNUMMER",
  "cart.inHouse.select.placeholder": "Tafel kiezen",
  "cart.inHouse.select.option": "Tafel #{n}",

  "cart.checkout.back": "Terug",
  "cart.payment.preparing": "Betaling voorbereiden…",
  "cart.loading": "Laden…",

  "mockCheckout.title.paymentMethod": "BETAALMETHODE",
  "mockCheckout.method.card": "Bankkaart",
  "mockCheckout.method.paypal": "PayPal",
  "mockCheckout.method.gpay": "Google Pay",
  "mockCheckout.cardForm.title": "VOER KAARTGEGEVENS IN",
  "mockCheckout.cardForm.numberLabel": "KAARTNUMMER",

  "mockCheckout.error.invalidCardNumber": "Ongeldig kaartnummer",
  "mockCheckout.error.enter16Digits": "Voer 16 cijfers in",
  "mockCheckout.error.expiryFormat": "Formaat MM/JJ",
  "mockCheckout.error.expiryMonthRange": "Maand 01–12",
  "mockCheckout.error.cardExpired": "Kaart is verlopen",
  "mockCheckout.error.cvc3Digits": "3 cijfers",

  "mockCheckout.error.sendTelegram": "Fout bij verzenden naar Telegram",
  "mockCheckout.error.generic": "Er is iets misgegaan",

  "mockCheckout.reserve.clientNotFound": "Klant niet gevonden",
  "mockCheckout.reserve.tablesNotFound": "Deze klant heeft geen tafelsectie",
  "mockCheckout.reserve.tableNotFound": "Tafel niet gevonden",
  "mockCheckout.reserve.alreadyReserved": "Deze tafel is net bezet geraakt. Kies alstublieft een andere.",
  "mockCheckout.reserve.noFreeTables": "Er zijn momenteel geen vrije tafels",
  "mockCheckout.reserve.tableNotSelected": "Kies alstublieft een tafel",
  "mockCheckout.reserve.genericError": "Reserveringsfout",

  "mockCheckout.button.back": "terug",
  "mockCheckout.button.pay": "BETALEN",
  "mockCheckout.button.sending": "…verzenden",
  "mockCheckout.button.paid": "...",
  "mockCheckout.button.payInvalidTitle": "Controleer de kaartgegevens",

  "admin.booking.lead.title": "MINIMALE RESERVERINGSTIJD",
  "admin.booking.lead.note": "Dit geldt alleen voor gastreserveringen in de modus 'tafel en tijd'. De stap is 30 minuten.",

  "dateTimeStep.select.time": "TIJD SELECTEREN",

  "admin.title": "ADMINPAGINA",
  "admin.loading": "Laden…",
  "admin.nav.delete": "Verwijderen",
  "admin.nav.back": "Terug",
  "admin.nav.next": "VOLGENDE",
  "admin.nav.confirm": "OPSLAAN",
  "admin.nav.confirm.now": "opslaan ...",
  "admin.booking.settings": "Reserveringsinstellingen",
  "admin.booking.deposit": "BEDRAG VAN DE AANBETALING",
  "admin.booking.deposit.note": "Aanbetaling wordt gerekend wanneer de gast alleen een tafel reserveert",

  "admin.hub.editmenu": "MENU BEWERKEN",
  "admin.hub.qr": "QR-CODE",
  "admin.hub.prices": "UW TARIEF",
  "admin.hub.settings": "INSTELLINGEN",

  "admin.panel.editmenu": "Menu bewerken",
  "admin.validation.required": "Verplicht veld",
  "admin.panel.add": "Positie toevoegen",
  "admin.panel.menu": "Menulijst bewerken",
  "admin.panel.telegram": "Telegram",
  "admin.panel.table": "TAFELBEHEER",
  "admin.set.table": "Zalen / tafels",
  "admin.set.logo": "Logo en achtergronden",
  "admin.logo.successfully.applied": "Logo succesvol toegepast",
  "admin.logo.download.error": "Downloadfout",
  "admin.settings.number.rooms": "Aantal zalen",
  "admin.settings.room": "Zaal",

  "admin.qr.title": "QR-code voor gasten",
  "admin.qr.alt": "QR-code voor restaurant",
  "admin.qr.copy": "link kopiëren",
  "admin.qr.copied": "✓ gekopieerd",
  "admin.qr.note": "Gasten kunnen deze code scannen om uw pagina direct te openen.",

  "admin.link.notfound": "Link niet gevonden",
  "admin.table.info": "Tafelbeheer is beschikbaar op deze pagina. De status wordt gewijzigd door op de tafel te drukken.",
  "admin.prices.temp": "Prijzen zijn tijdelijk niet beschikbaar.",
  "admin.forgot.password": "Wachtwoord vergeten?",
  "admin.success.description": "Klik op OK en voeg nog een product toe",

  "order.success": "Item toegevoegd aan de winkelwagen!",
  "order.error": "Dit item staat al in de winkelwagen",

  "popap.product.removal": "Product verwijderen",
  "popap.category.removal": "Categorie verwijderen",
  "popap.want.delete.product": "Weet u zeker dat u het product wilt verwijderen",
  "popap.want.delete.category": "Weet u zeker dat u de categorie wilt verwijderen?",

  "admin.settings.guestLang": "Standaardtaal voor gasten",
  "admin.settings.adminLang": "Standaardtaal voor admin",
  "admin.settings.noteGuest": "Deze taal wordt als standaard ingesteld wanneer gasten de pagina openen.",
  "admin.settings.noteAdmin": "Deze taal wordt als standaard ingesteld in het adminpaneel.",
  "admin.language": "Taal",
  "admin.settings.logo": "Logo van het restaurant",
  "admin.settings.logo.text": "Upload uw logo (PNG/JPG/WEBP/SVG, tot 2 MB). Klik daarna op “Opslaan”; dit vervangt het huidige logo door het nieuwe.",
  "admin.settings.backtable": "Achtergrondafbeelding op het scherm voor tafelselectie",
  "admin.settings.backhome": "Achtergrondafbeelding van het startscherm",
  "admin.settings.backtable.text": "Upload een achtergrondafbeelding (SVG/PNG/JPG/WEBP). Klik daarna op “Opslaan”; dit vervangt de huidige achtergrond door de nieuwe.",
  "admin.settings.language.visitors": "Hoofdtaal voor bezoekers van het restaurant",
  "admin.settings.language.visitors.text": "Deze taal wordt ingesteld als primaire taal wanneer gasten de pagina openen",
  "admin.settings.language.admin": "De hoofdtaal voor uw adminpaneel",
  "admin.settings.language.admin.text": "Deze taal wordt als standaard ingesteld wanneer het adminpaneel wordt geopend",
  "admin.settings.gallery": "Galerij",
  "admin.settings.social": "Sociale netwerken",
  "admin.settings.number.tables": "Aantal tafels",
  "admin.settings.how.many.tables": "Hoeveel tafels zijn er in het restaurant?",
  "admin.settings.tables.test": "Sla het aantal tafels op en ga terug naar het vorige tabblad om de instellingen voor elke tafel afzonderlijk te configureren.",
  "admin.settings.upload.panoramic": "Upload een panoramafoto van de zaal van uw restaurant",
  "admin.settings.table": "Tafel",
  "admin.settings.table.not.found": "Tafel niet gevonden",
  "admin.settings.contact.details": "Contactgegevens",
  "admin.contacts.company": "Bedrijfsnaam",
  "admin.contacts.address": "Adres",
  "admin.contacts.phone": "Telefoonnummer",
  "admin.socials.title": "Sociale media",
  "admin.settings.rooms.hint": "Geef het aantal zalen in het restaurant op",

  "admin.settable.title": "Stap 3. Tafelnummering",
  "admin.settable.text1": "Elk label heeft een nummer; plaats de labels volgens de tafelnummers.",
  "admin.settable.text2": "Gebruik de schakelaar om de labelgrootte te wijzigen.",
  "admin.settable.text3": "Sla de gegevens van de huidige tafel op en klik op het bijbehorende pictogram om tussen tafels te wisselen.",
  "admin.setqr.title": "Uw QR-codes",
  "admin.setqr.text1": "op deze pagina worden uw berichten, menu's en QR-codes opgeslagen",
  "admin.setqr.text2": "bij aankoop van een BASIC-tarief wordt automatisch een QR-code en een link naar uw subdomeinnaam gegenereerd (bijvoorbeeld example.best-place.club)",
  "admin.setqr.text3": "u kunt de link openen, kopiëren en de QR-code ook als afbeelding op uw apparaat opslaan",
  "admin.setpanorama.title": "Stap 2. Panoramafoto",
  "admin.setpanorama.text1": "Voeg een panoramafoto toe. Het wordt aanbevolen om lichte bestanden te gebruiken (bijvoorbeeld WEBP-formaat).",
  "admin.setpanorama.text2": "Als de afbeelding succesvol is geüpload, ziet u deze in de onderstaande preview.",
  "admin.setnumber.title": "Stap 1. Aantal tafels",
  "admin.setnumber.text1": "Kies het aantal tafels in uw restaurant",
  "admin.setnumber.text2": "Het wordt aanbevolen om de configuratie met één of twee tafels te starten en het aantal daarna te verhogen.",

  "admin.current.logo": "Huidig logo",
  "admin.add.photo": "hier kunt u een bestand toevoegen",
  "admin.add.file": "bestandsformaten voor upload: .xlsx, .xls, .csv",
  "admin.add.file.but": "Bestand toevoegen",
  "admin.import.format": "Kolomformaat: Categorie / Titel / Beschrijving / Prijs",
  "admin.import.follow": "volg het opgegeven kolomformaat en bereid een bestand in het juiste formaat voor",
  "admin.import.BeСareful": "Let op: eerdere gegevens gaan verloren tijdens de import",
  "admin.add.photo.but": "Foto toevoegen",
  "admin.add.photo.set": "Foto toevoegen",

  "admin.wizard.step1": "Categorie kiezen",
  "admin.wizard.step2": "Naam en prijs",
  "admin.wizard.step3": "Beschrijving en foto",
  "admin.wizard.ready": "Klaar",
  "admin.wizard.defaultTitle": "Product toevoegen",
  "admin.wizard.step1.desc": "Stap 1. Kies een bestaande categorie of maak een nieuwe aan",
  "admin.wizard.step2.desc": "Stap 2. Kies een naam voor uw product en stel een prijs in",
  "admin.wizard.step3.desc": "Stap 3. Schrijf een productbeschrijving, voeg een afbeelding toe en klik op opslaan",
  "admin.wizard.step1.desc.short": "Stap 1. Selecteer een bestaande of nieuwe categorie",
  "admin.wizard.step2.desc.short": "Stap 2. Voeg de naam en prijs van het product toe",
  "admin.wizard.step3.desc.short": "Stap 3. Beschrijf het product en voeg een foto toe",

  "admin.wizard.tab.existing": "Bestaand",
  "admin.wizard.tab.new": "Nieuw",
  "admin.wizard.cat.loading": "Laden…",
  "admin.wizard.cat.empty": "Nog geen categorieën. Schakel over naar “Nieuw” en maak de eerste aan.",

  "admin.form.categoryKeyDe": "Categorie (KEY/NL)",
  "admin.form.categoryEn": "Categorie (EN)",
  "admin.form.titleMain": "Productnaam",
  "admin.form.descMain": "Productbeschrijving",
  "admin.validation.req": "Voer de productnaam in",
  "admin.form.titleDe": "Titel (DE)",
  "admin.form.titleEn": "Titel (EN)",
  "admin.form.nameDe": "Naam (DE)",
  "admin.form.nameEn": "Naam (EN)",
  "admin.form.price": "Prijs",
  "admin.form.descDe": "Beschrijving (DE)",
  "admin.form.descEn": "Beschrijving (EN)",

  "admin.toast.productAdded": "Product succesvol toegevoegd",
  "admin.tooltip.fixFormErrors": "Los de fouten in het formulier op",

  "admin.validation.firstCharNotDigit": "Het eerste teken mag geen cijfer zijn.",
  "admin.validation.maxChars": "verkort de productnaam",
  "admin.validation.chooseCategory": "Kies een categorie.",
  "admin.validation.chooseCategoryFromList": "Kies een categorie uit de lijst.",
  "admin.validation.enterCategoryName": "Voer een categorienaam in.",
  "admin.validation.enterProductName": "Voer een productnaam in.",
  "admin.validation.priceFormat": "Ongeldig prijsformaat (bijv. 12.50)",
  "admin.validation.enterDescription": "Voer een beschrijving in.",
  "admin.tarif.apply": "toepassen",
  "admin.menu.creating": "Menu maken",
  "admin.choose.template": "Stap 1: Kies een sjabloon",
  "admin.choose.template2": "Stap 2: Controleer de productregels",
  "admin.choose.atyle": "Kies een menustijl. U kunt deze later wijzigen",

  "admin.error.tenantNotFound": "Geen klant gevonden voor dit subdomein.",
  "admin.error.resolveClient": "Klant kon niet worden bepaald.",
  "admin.error.menuLoad": "Menu kon niet worden geladen.",
  "admin.error.saveLang": "Taal kon niet worden opgeslagen.",
  "admin.error.clientNotFound": "Klant niet gevonden op de server",
  "admin.error.arrNotFound": "Gegevensarray niet gevonden voor deze klant",

  "tpl.premium.title": "Premium",
  "tpl.classic.title": "Klassiek",
  "tpl.dark.title": "Donker",
  "tpl.minimal.title": "Minimalistisch",
  "tpl.premium.desc": "Bestseller",
  "tpl.classic.desc": "licht",
  "tpl.dark.desc": "donker",
  "tpl.minimal.desc": "minimalistisch",

  "tp2.position.total": "U heeft nu:",
  "tp2.position.punkte": "Menu-items",
  "tp2.position.template": "Sjabloon",

  "tp3.qr.link": "QR-code en menulink",
  "tp3.step3.title": "Stap 3: Preview / Publiceren",
  "admin.tp.progres.publication": "Publicatie",
  "admin.tp.progres.positionen": "Positie",

  "tp4.link.copy": "KOPIËREN",
  "tp4.link.copy.ok": "✓ GEKOPIEERD",

  "admin.tp.publish": "Publiceren",
  "admin.tp.posting": "publiceren ...",

  "admin.import.from.excel": "Menu importeren vanuit Excel",

  "popap.successful.payment": "Betaling succesvol",

  "landing.title": "Digitale oplossingen voor restaurants",
  "landing.title.login": "Inloggen",
  "landing.text": "Lanceer uw restaurantwebsite in enkele minuten!",
  "landing.try.now": "gratis proberen",
  "landing.title.to": "Voor wie is onze service geschikt?",
  "landing.title.answer": "In de eerste plaats is deze service nuttig voor eigenaren van horecazaken die nieuwe klanten willen aantrekken en bestaande klanten willen behouden",
  "landing.content.title.first": "Online menu met QR-code",
  "landing.content.first": "Uw bezoekers kunnen rekenen op een actueel menu en actuele prijzen door simpelweg de QR-code te scannen. Speciale aanbiedingen verhogen de loyaliteit van bezoekers aan uw product",
  "landing.content.title.second": "Online tafelreserveringen",
  "landing.content.second": "Wij bieden uw gasten een visuele online tafelreservering met extra panoramafoto's. Indien nodig kunnen zij tussen aangrenzende zones wisselen",
  "landing.content.title.third": "Sfeervolle content",
  "landing.content.third": "Uw potentiële bezoekers kunnen verschillende soorten content bekijken: foto's van het interieur, video's van de bereiding van topgerechten en een panoramisch uitzicht op de zaal.",
  "landing.content.title.four": "Verhoog uw gemiddelde bon",
  "landing.content.four": "Bied uw gasten evenementen aan zoals banketten, verjaardagen of speciale aanbiedingen voor uitgebreide of dagelijkse bestellingen",
  "landing.request": "Wij nemen binnenkort contact met u op",
  "callback.invalidPhone": "Voer een geldig telefoonnummer in",
  "landing.enter.number": "UW NUMMER",
  "callback.submitError": "Het nummer kon niet worden verzonden. Probeer het opnieuw",
  "landing.tariff.advance": "Waarschuwing",
  "landing.tariff.advance.desc": "Binnen het gekozen tarief kunt u uw applicatie gratis met content vullen",
  "landing.tariff.one-time-not-included": "Individuele prijsberekening. In de rechterhoek van het scherm vindt u een contactknop. Laat uw nummer achter en wij nemen contact met u op",
  "landing.tariff.one-time-services": "Eenmalige diensten",
  "landing.tariff.logo-creation": "Logo maken",
  "landing.tariff.selling-images": "Productafbeeldingen verkopen",
  "landing.tariff.panorama-creation": "Panorama maken",

  "demo.video.unsupported": "Uw browser ondersteunt geen video",
  "demo.title.after": "overzicht van de service",
  "demo.title.accent": "kort",
  "demo.title.before": "Een",
  "demo.title.total": "over de service",
  "demo.title": "Video-overzicht",

  "landing.free.first": "Online menu via QR-code beschikbaar, resultaat binnen enkele minuten.",
  "landing.free.second": "De mogelijkheid om het menu voor de huidige datum te bewerken",
  "landing.free.third": "Toegang tot de menu-ontwerper",
  "landing.basic.first": "Een volledige URL-pagina met menutoegang via QR-code",
  "landing.basic.second": "Online bestellen voor uw bezoekers",
  "landing.basic.third": "Online tafelreserveringen, panoramafoto's van uw eetzaal, klikbare tafels en realtime weergave van gereserveerde en beschikbare tafels",
  "landing.basic.fourth": "Menu met vertaling in elke gewenste taal",
  "landing.pro.first": "Functionaliteit waarmee u prijsaanbiedingen kunt beheren, banners kunt maken en marketingstrategieën kunt ontwikkelen",
  "landing.pro.second": "De mogelijkheid om het loyaliteitssysteem voor gasten te beheren en invloed uit te oefenen op het eindresultaat van Google-reviews",
  "landing.pro.third": "",
  "landing.title.free": "14 dagen gratis",
  "landing.registerTitle": "Registratie",
  "landing.tariff.selection": "Tariefkeuze",
  "landing.tariff.subdomain": "Subdomeinregistratie",
  "landing.tariff": " / per maand",
  "landing.your.tariff": "uw tarief",
  "landing.your.example": "bijvoorbeeld",
  "landing.Subdomain.selection": "Subdomein kiezen",
  "landing.password": "wachtwoord",
  "landing.tariff.free": "GRATIS",
  "landing.tariff.free-description": "om kennis te maken met de service",
  "landing.tariff.basic": "BASIC",
  "landing.tariff.basic-description": "basisfuncties om te starten",
  "landing.tariff.pro": "PRO",
  "landing.tariff.pro-description": "Voor gevorderde gebruikers",
  "landing.tariff.selected": "✓ geselecteerd",
  "landing.legal.text.start": "Ik ga akkoord met de",
  "footer.legal.terms": "Voorwaarden",
  "landing.legal.text.mid": "en",
  "landing.tariff.optional": "Eenmalige diensten",
  "landing.tariff.one-time-note": "Bekijk tarieven voor het maken van hoogwaardige, verkoopgerichte afbeeldingen",
  "landing.tariff.pro-locked-desc": "Dit tarief is nog niet beschikbaar",
  "landing.tariff.in-development": "In ontwikkeling",
  "landing.tariff.free-one-time-desc": "voor het vullen van uw publicatie met hoogwaardige afbeeldingen",

  "footer.legal.privacy": "Privacy",
  "footer.legal.privacy.and": "beleid",
  "footer.about": "Platform voor restaurants: menu, tafelreserveringen, bestellingen en adminpaneel.",

  "server.common.unknown": "Onbekende fout.",
  "server.common.serverError": "Interne serverfout.",
  "server.common.networkError": "Netwerkfout. Probeer het opnieuw.",
  "server.common.clientIdMissing": "Fout: clientId ontbreekt.",

  "server.login.required": "E-mail en wachtwoord zijn verplicht.",
  "server.login.invalidCredentials": "Ongeldig e-mailadres of wachtwoord.",
  "server.login.signupIncomplete": "Account is nog niet actief. Rond de registratie af.",
  "server.login.success": "Inloggen gelukt!",

  "server.register.required": "E-mail en wachtwoord zijn verplicht.",
  "server.register.emailExistsActive": "Er bestaat al een gebruiker met dit e-mailadres. Gebruik Login.",
  "server.register.resume": "Registratie wordt voortgezet.",
  "server.register.success": "Registratie gelukt!",

  "server.signupComplete.success": "Activatie gelukt!",
  "server.signupComplete.error": "Activatie mislukt.",

  "server.subdomain.required": "clientId en subdomein zijn verplicht.",
  "server.subdomain.planInvalid": "Ongeldig tarief. Toegestaan: free | basic | pro.",
  "server.subdomain.invalid": "Ongeldig subdomein (a-z, 0-9, '-', 3–30, geen '-' aan het begin/einde).",
  "server.subdomain.reserved": "Dit subdomein is gereserveerd.",
  "server.subdomain.taken": "Dit subdomein is al in gebruik.",
  "server.subdomain.userNotFound": "Gebruiker niet gevonden.",
  "server.subdomain.success": "Subdomein geregistreerd. Doorsturen…",
  "server.subdomain.error": "Subdomeinregistratie mislukt.",

  "landing.loginTitle": "Login",
  "landing.btn.login": "Login",
  "landing.btn.register": "Registratie",
  "landing.btn.enter": "Binnenkomen",
  "landing.loggingIn": "Inloggen…",
  "landing.registering": "Registreren…",
  "landing.activating": "Activeren…",
  "landing.subdomain.registering": "Subdomein registreren…",
  "landing.redirecting": "Doorsturen…",
  "landing.legal.required": "Accepteer alstublieft de voorwaarden en privacyverklaring.",

  "landing.subdomain.err.empty": "Voer een subdomein in.",
  "landing.subdomain.err.chars": "Alleen letters, cijfers en '-', 3–30 tekens.",
  "landing.subdomain.err.hyphen": "Subdomein mag niet beginnen of eindigen met '-'.",
  "landing.subdomain.err.reserved": "Dit subdomein is gereserveerd.",

  "admin.menuLanguages.title": "Menutalen",
  "admin.menuLanguages.default": "De taal die een bezoeker van uw zaak als eerste te zien krijgt (standaard)",
  "admin.menuLanguages.hint": "Selecteer de talen die aanvullend gebruikt zullen worden.",
  "common.success": "Gelukt",
  "admin.import.activeLangs": "Actieve menutalen",
  "admin.import.sourceLangHint": "Excel wordt alleen in de geselecteerde taal weergegeven. Andere actieve talen blijven leeg",
  "admin.import.sourceLang": "Geef de taal op waarin het Excel-bestand is geschreven",
  "admin.import.mainLang": "de belangrijkste",
  "booking.date.today": "Vandaag",
  "booking.date.tomorrow": "Morgen",
  "booking.room": "Zaal",

  "front.faq.chat.answer.greeting": "Hallo! Ik kan helpen met reserveringen, het menu, adres, openingstijden en andere vragen.",
"front.faq.chat.answer.howAreYou": "Dank je, het gaat goed! Waarmee kan ik je helpen over het restaurant?",
"front.faq.chat.answer.thanks": "Graag gedaan! Stel gerust nog een vraag als je iets wilt weten.",
"front.faq.chat.answer.goodbye": "Tot ziens! We kijken uit naar je bezoek.",
"front.faq.chat.answer.whoAreYou": "Ik ben de digitale assistent van het restaurant. Ik help gasten met veelgestelde vragen.",
"front.faq.chat.answer.help": "Ik kan helpen met reserveringen, het menu, adres, telefoonnummer, betalingen, allergenen, bezorging en andere vragen.",
"front.faq.chat.answer.recommendation": "Ik raad aan om het menu te bekijken — daar vind je de actuele gerechten en kun je kiezen wat het beste bij je past.",
"front.faq.chat.answer.compliment": "Hartelijk dank! Dat vinden we erg fijn om te horen.",

"checkout.button.send": "ENVOYER",
"checkout.button.sending": "Envoi en cours ...",
"checkout.button.sent": "Envoyé",
"checkout.title.order": "BESTELLING",
"checkout.phone.title": "Voer je telefoonnummer in",
"checkout.phone.label": "Telefoonnummer",

"footer.workingHours": "Werktijden",

"admin.offline.title": "Geen internetverbinding",
"admin.offline.text": "Controleer je internetverbinding. Zodra de verbinding is hersteld, kun je automatisch verder werken.",
"admin.offline.status": "Wachten op verbinding…",


};

export default nl;